module.exports = __webpack_public_path__ + "static/circle4-8bdab25da138b218390089157d8db8fd.png";